module.exports = __webpack_public_path__ + "static/media/01B.de315718.png";